module.exports = __webpack_public_path__ + "img/chartgif.cadaf3ee.gif";